import { motion } from "framer-motion";
import { Reveal } from "../Reveal";
import { ASSETS } from "../assets";

export default function Slide01Cover() {
  return (
    <section className="slide bg-[var(--ais-espresso)]" data-testid="slide-01">
      <div className="absolute inset-0">
        <img
          src={ASSETS.pythonLoafer}
          alt="AIS — Velo Loafer in python leather with fringe"
          className="w-full h-full object-cover kenburns"
          style={{ objectPosition: "center 55%" }}
        />
        {/* Strong dark left column for legibility over a bright warm image */}
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--ais-espresso)] from-0% via-[var(--ais-espresso)]/88 via-40% to-[var(--ais-espresso)]/10 to-90%" />
        <div className="absolute inset-0 bg-gradient-to-t from-[var(--ais-espresso)]/50 via-transparent to-[var(--ais-espresso)]/45" />
      </div>

      <div className="relative min-h-screen flex items-center px-6 md:px-16 lg:px-24">
        <div className="max-w-4xl">
          <Reveal delay={0}>
            <div className="hairline w-24 mb-10" />
          </Reveal>
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className="font-serif text-[var(--ais-cream)] text-5xl md:text-7xl lg:text-[6.25rem] leading-[1.02] tracking-[-0.01em] font-light drop-shadow-[0_2px_28px_rgba(0,0,0,0.9)]"
          >
            A new Italian
            <br />
            luxury house,
            <br />
            built <em className="italic font-light text-[var(--ais-gold)]">for the Gulf</em>.
          </motion.h1>
          <Reveal delay={3}>
            <p className="mt-10 font-sans text-[var(--ais-cream)] text-base md:text-lg max-w-xl font-light leading-[1.85] drop-shadow-[0_1px_14px_rgba(0,0,0,0.95)]">
              An Italian artisan house, conceived from inception for the Gulf
              market and its culture of luxury.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
